import { dataDogProvider } from './gatsbySetup/rootElement/datadogProvider';
export const wrapRootElement = dataDogProvider;
